/**
 * Form khai báo sử dụng AI khi nộp bài (TT 83 C5 — chức năng #5).
 * Cấm AI → chỉ cần xác nhận "không dùng" (vẫn cho khai đã dùng — trung thực hơn giấu).
 */
import { Alert, Checkbox, Form, Input, Modal, Radio, Select } from "antd";

import {
  AI_PURPOSE_LABEL,
  type AiDeclarationInput,
  type StudentAiPolicy,
} from "@/features/ai/aiPolicy";

export function AiDeclarationModal({
  open,
  policy,
  answeredText,
  submitting,
  onCancel,
  onSubmit,
}: {
  open: boolean;
  policy: StudentAiPolicy;
  answeredText: string;
  submitting: boolean;
  onCancel: () => void;
  onSubmit: (d: AiDeclarationInput) => void;
}) {
  const [form] = Form.useForm<AiDeclarationInput>();
  const usedAi = Form.useWatch("used_ai", form);

  return (
    <Modal
      open={open}
      title="Khai báo sử dụng AI và nộp bài"
      okText="Nộp bài"
      cancelText="Quay lại"
      confirmLoading={submitting}
      onCancel={onCancel}
      onOk={() => form.submit()}
      destroyOnClose
    >
      <p>{answeredText}</p>
      {policy.level === "prohibited" && (
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 12 }}
          message="Bài này CẤM dùng AI. Khai báo trung thực — khai sai là vi phạm quy chế."
        />
      )}
      <Form
        form={form}
        layout="vertical"
        initialValues={{ tools: [], purposes: [], detail: "" }}
        onFinish={(v) =>
          onSubmit({
            used_ai: v.used_ai,
            tools: v.used_ai ? (v.tools ?? []) : [],
            purposes: v.used_ai ? (v.purposes ?? []) : [],
            detail: v.used_ai ? (v.detail ?? "") : "",
          })
        }
      >
        <Form.Item
          name="used_ai"
          label="Bạn có dùng công cụ AI (ChatGPT, Gemini, Copilot, AI Tutor…) khi làm bài này không?"
          rules={[{ required: true, message: "Chọn một phương án" }]}
        >
          <Radio.Group
            options={[
              { value: false, label: "Không dùng" },
              { value: true, label: "Có dùng" },
            ]}
          />
        </Form.Item>
        {usedAi && (
          <>
            <Form.Item name="tools" label="Công cụ đã dùng">
              <Select mode="tags" placeholder="Gõ tên công cụ rồi Enter" maxCount={10} />
            </Form.Item>
            <Form.Item
              name="purposes"
              label="Dùng để làm gì"
              rules={[{ required: true, message: "Chọn ít nhất 1 mục đích" }]}
            >
              <Checkbox.Group
                options={Object.entries(AI_PURPOSE_LABEL).map(([value, label]) => ({
                  value,
                  label,
                }))}
              />
            </Form.Item>
            <Form.Item name="detail" label="Mô tả thêm (phần nào, mức độ)">
              <Input.TextArea rows={3} maxLength={2000} />
            </Form.Item>
          </>
        )}
      </Form>
    </Modal>
  );
}
